import { FC } from 'react';
import styles from './TabContext.module.css';
import { TabContext as MuiTabContext, TabContextProps as MuiTabContextProps } from '@mui/lab';

interface TabContextProps extends MuiTabContextProps { }

const TabContext: FC<TabContextProps> = ({ ...props }) => (
  <div className={styles.TabContext}>
    <MuiTabContext {...props} />
  </div>
);

export default TabContext;
